import { Row, Col } from 'antd'
import './index.less'

export { Row, Col }



// WEBPACK FOOTER //
// ./src/elements/grid-row/index.js